export default {
  type: "warehouses",
  name: null,
  applied_at: null,
  is_model: false,
  taxGroups: [],
  allow_negative_inventory: false,
  allow_unregistered_products: false,
  use_warehouse_taxes: false,
  excerpt: "",
  relationshipNames: [
    "organization",
    "allowedLocations",
    "modelUsed",
    "usedBy",
    "taxGroups",
  ],
  organization: {
    type: "organizations",
    id: null,
  },
  modelUsed: {
    type: "warehouses",
    id: null,
  },
  allowedLocations: [],
  usedBy: [],
};
